import { PlanTemplateType } from "../../templates/generated/template_types";
import type { PlaniraTemplate } from "../../templates/types";
import {
  ModuleDoneType,
  ModuleType,
  PlanQuestionType,
  PlanType,
} from "../../templates/types";

export const QuickstartDatesTemplate: PlaniraTemplate = {
  planType: PlanType.Quickstart,
  type: PlanTemplateType.QuickstartDates,
  title: "Find dates",
  description:
    "Easily mark everyone's availability on the calendar to find the best dates.",
  longDescription: "",
  emoji: "📅",
  titleHelp: "Next trip, When to eat out, When to celebrate...",

  image: require("../../assets/illustrations/Calendar-cuate.svg"),
  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Find dates",
          isDraggable: false,
          emoji: "📅",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "Calendar",
          emoji: "📅",
          questionOption: {
            question: "Do you know when you're going?",
            questionType: PlanQuestionType.Dates,
          },
        },
      ],
    },
  ],
};
